export default interface SerPartEditModel {
    id: number;
    combinedData: string;
}

export const serPartEditModelDefaultProps: SerPartEditModel = {
    id: 0,
    combinedData: "--",
}